// Mock data for Brazolovers - Menú completo actualizado

export const brazosGitanos = [
  // Clásicos (10 sabores)
  {
    id: 1,
    name: "Manjar",
    description: "Bizcocho esponjoso sabor a vainilla, cubierto y relleno de manjar. Uno de nuestros clásicos. Puedes escoger el topping entre chispas de chocolate o coco rallado.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Clásico",
    availableSlice: true,
    availableFull: true
  },
  {
    id: 2,
    name: "Choco Manjar",
    description: "Bizcocho esponjoso de chocolate, relleno de manjar y cubierto de chocolate. La combinación perfecta.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1e8c6bcd-0ee6-4bb6-bad8-3d7aaaed21de.jpg",
    category: "Clásico",
    availableSlice: true,
    availableFull: true
  },
  {
    id: 3,
    name: "Vainilla",
    description: "Clásico bizcocho de vainilla con crema de vainilla. Simple y delicioso.",
    priceSlice: 3.50,
    priceFull: 17.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Clásico"
  },
  {
    id: 4,
    name: "Chocolate",
    description: "Bizcocho de chocolate puro con crema de chocolate. Para los chocolateros de corazón.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/8de978ec-73b2-4ccd-ab62-25a2c32159bb.jpg",
    category: "Clásico"
  },
  {
    id: 5,
    name: "Mantequilla",
    description: "Bizcocho tradicional de mantequilla con crema suave. Sabor casero y reconfortante.",
    priceSlice: 3.50,
    priceFull: 17.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Clásico"
  },
  {
    id: 6,
    name: "Coco",
    description: "Bizcocho de vainilla con relleno de crema de coco y coco rallado. Tropical y cremoso.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Clásico"
  },
  {
    id: 7,
    name: "Nata",
    description: "Bizcocho suave con nata montada. Ligero y esponjoso.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Clásico"
  },
  {
    id: 8,
    name: "Crema Pastelera",
    description: "Bizcocho de vainilla con crema pastelera tradicional. Suave y sedoso.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Clásico"
  },
  {
    id: 9,
    name: "Mora",
    description: "Bizcocho de vainilla con mermelada de mora artesanal. Dulce y frutal.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1f20a765-7a3a-48f4-a36c-1b0bc2733c31.jpg",
    category: "Clásico"
  },
  {
    id: 10,
    name: "Guanábana",
    description: "Bizcocho con mousse de guanábana. Sabor tropical único.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Clásico"
  },

  // Especiales (15 sabores)
  {
    id: 11,
    name: "Encanelado",
    description: "Bizcocho esponjoso sabor a canela relleno de manjar. Un clásico reinventado con el aroma cálido de la canela.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Especial"
  },
  {
    id: 12,
    name: "Frutilla",
    description: "Bizcocho esponjoso de vainilla, relleno y cubierto con frosting de queso crema y mermelada de frutilla artesanal.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1f20a765-7a3a-48f4-a36c-1b0bc2733c31.jpg",
    category: "Especial"
  },
  {
    id: 13,
    name: "Zanahoria",
    description: "Bizcocho de zanahoria con especias, relleno de frosting de queso crema. Suave y delicioso.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Especial"
  },
  {
    id: 14,
    name: "Tres Leches",
    description: "Bizcocho empapado en tres leches con crema batida. Húmedo y delicioso.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/9996d964-97d1-4732-babc-5809b97f46d2.jpg",
    category: "Especial"
  },
  {
    id: 15,
    name: "Limón",
    description: "Bizcocho de vainilla con relleno de crema de limón. Refrescante y dulce.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1f20a765-7a3a-48f4-a36c-1b0bc2733c31.jpg",
    category: "Especial"
  },
  {
    id: 16,
    name: "Maracuyá",
    description: "Bizcocho de vainilla con relleno de mousse de maracuyá. Tropical y aromático.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Especial"
  },
  {
    id: 17,
    name: "Naranja",
    description: "Bizcocho de naranja con relleno de crema de mantequilla de naranja. Cítrico y suave.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Especial"
  },
  {
    id: 18,
    name: "Café",
    description: "Bizcocho de café con relleno de crema de café. Para los amantes del café.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/9996d964-97d1-4732-babc-5809b97f46d2.jpg",
    category: "Especial"
  },
  {
    id: 19,
    name: "Banana",
    description: "Bizcocho de banana con crema de vainilla. Suave y aromático.",
    priceSlice: 3.80,
    priceFull: 18.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Especial"
  },
  {
    id: 20,
    name: "Durazno",
    description: "Bizcocho con crema y trozos de durazno. Frutal y delicado.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1f20a765-7a3a-48f4-a36c-1b0bc2733c31.jpg",
    category: "Especial"
  },
  {
    id: 21,
    name: "Piña",
    description: "Bizcocho con crema y piña natural. Tropical y refrescante.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Especial"
  },
  {
    id: 22,
    name: "Mango",
    description: "Bizcocho con mousse de mango. Sabor tropical intenso.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Especial"
  },
  {
    id: 23,
    name: "Cereza",
    description: "Bizcocho con crema y cerezas. Elegante y delicioso.",
    priceSlice: 4.20,
    priceFull: 20.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1f20a765-7a3a-48f4-a36c-1b0bc2733c31.jpg",
    category: "Especial"
  },
  {
    id: 24,
    name: "Arándanos",
    description: "Bizcocho con crema y arándanos frescos. Frutal y saludable.",
    priceSlice: 4.20,
    priceFull: 20.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1f20a765-7a3a-48f4-a36c-1b0bc2733c31.jpg",
    category: "Especial"
  },
  {
    id: 25,
    name: "Almendra",
    description: "Bizcocho con crema de almendra y almendras laminadas. Elegante y crujiente.",
    priceSlice: 4.20,
    priceFull: 20.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/9996d964-97d1-4732-babc-5809b97f46d2.jpg",
    category: "Especial"
  },

  // Premium (15 sabores)
  {
    id: 26,
    name: "Caramel Moka",
    description: "Bizcocho de chocolate o vainilla relleno y cubierto de crema de café y chocolate decorado con praliné de almendra y nueces.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/9996d964-97d1-4732-babc-5809b97f46d2.jpg",
    category: "Premium"
  },
  {
    id: 27,
    name: "Choco Choco",
    description: "Doble chocolate para los amantes del cacao. Bizcocho de chocolate con relleno y cobertura de ganache de chocolate intenso.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/8de978ec-73b2-4ccd-ab62-25a2c32159bb.jpg",
    category: "Premium"
  },
  {
    id: 28,
    name: "Choco Maní",
    description: "Bizcocho esponjoso de chocolate, relleno y cubierto con ganache de chocolate y maní.",
    priceSlice: 4.00,
    priceFull: 19.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/5447752e-2e49-46ac-b6ec-740c682abb20.jpg",
    category: "Premium"
  },
  {
    id: 29,
    name: "Oreo",
    description: "Bizcocho esponjoso de chocolate relleno y cubierto de crema de oreo. Un favorito entre niños y adultos.",
    priceSlice: 4.20,
    priceFull: 20.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/4d313ae7-8cb2-43fc-a936-cbdf1f95c45a.jpg",
    category: "Premium"
  },
  {
    id: 30,
    name: "Red Velvet",
    description: "Bizcocho aterciopelado de cacao relleno de frosting de queso crema. Un clásico americano.",
    priceSlice: 4.20,
    priceFull: 20.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/d1bd31da-2da2-420d-89b1-c1adfd9e6cf9.jpg",
    category: "Premium"
  },
  {
    id: 31,
    name: "Frutos Rojos",
    description: "Bizcocho de vainilla con relleno de crema y frutos rojos naturales. Dulce y frutal.",
    priceSlice: 4.20,
    priceFull: 20.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/1f20a765-7a3a-48f4-a36c-1b0bc2733c31.jpg",
    category: "Premium"
  },
  {
    id: 32,
    name: "Cookies & Cream",
    description: "Bizcocho de chocolate con trozos de galleta oreo y crema. Irresistible.",
    priceSlice: 4.20,
    priceFull: 20.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/4d313ae7-8cb2-43fc-a936-cbdf1f95c45a.jpg",
    category: "Premium"
  },
  {
    id: 33,
    name: "Nutella",
    description: "Bizcocho de chocolate relleno de Nutella. Cremoso y chocolatoso.",
    priceSlice: 4.50,
    priceFull: 21.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/8de978ec-73b2-4ccd-ab62-25a2c32159bb.jpg",
    category: "Premium"
  },
  {
    id: 34,
    name: "Ferrero Rocher",
    description: "Bizcocho de chocolate con crema de avellana y Ferrero Rocher. Lujo en cada bocado.",
    priceSlice: 5.00,
    priceFull: 23.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/9996d964-97d1-4732-babc-5809b97f46d2.jpg",
    category: "Premium"
  },
  {
    id: 35,
    name: "Tiramisu",
    description: "Bizcocho de café empapado con crema de mascarpone. Elegante sabor italiano.",
    priceSlice: 4.50,
    priceFull: 21.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/9996d964-97d1-4732-babc-5809b97f46d2.jpg",
    category: "Premium"
  },
  {
    id: 36,
    name: "Baileys",
    description: "Bizcocho de chocolate con crema de Baileys. Para adultos sofisticados.",
    priceSlice: 4.50,
    priceFull: 21.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/8de978ec-73b2-4ccd-ab62-25a2c32159bb.jpg",
    category: "Premium"
  },
  {
    id: 37,
    name: "Pistache",
    description: "Bizcocho con crema de pistache. Sabor único y exquisito.",
    priceSlice: 4.80,
    priceFull: 22.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/21fc14d1-d076-43ab-bba2-eb4514aae417.jpg",
    category: "Premium"
  },
  {
    id: 38,
    name: "Chocotejas",
    description: "Bizcocho con chocotejas peruanas y manjar. Fusión deliciosa.",
    priceSlice: 4.50,
    priceFull: 21.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/8de978ec-73b2-4ccd-ab62-25a2c32159bb.jpg",
    category: "Premium"
  },
  {
    id: 39,
    name: "Snickers",
    description: "Bizcocho de chocolate con caramelo, maní y chocolate. Explosión de sabores.",
    priceSlice: 4.50,
    priceFull: 21.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/5447752e-2e49-46ac-b6ec-740c682abb20.jpg",
    category: "Premium"
  },
  {
    id: 40,
    name: "Kinder Bueno",
    description: "Bizcocho con crema de avellana y Kinder Bueno. Irresistible para todos.",
    priceSlice: 4.80,
    priceFull: 22.00,
    image: "https://d2nagnwby8accc.cloudfront.net/companies/products/images/800/8de978ec-73b2-4ccd-ab62-25a2c32159bb.jpg",
    category: "Premium"
  }
];

export const galletas = [
  {
    id: 1,
    name: "Choco Chips",
    description: "Galletas caseras con chispas de chocolate",
    priceUnit: 1.50,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/q7kru7hb_01%20Chocochips.jpg",
    available: true,
    type: "individual"
  },
  {
    id: 2,
    name: "Choco Nuez",
    description: "Galletas de chocolate con trozos de nuez",
    priceUnit: 1.50,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/6m0v0wqj_02%20ChocoNuez.jpg",
    available: true,
    type: "individual"
  },
  {
    id: 3,
    name: "Red Velvet",
    description: "Galletas de red velvet con chips de chocolate blanco",
    priceUnit: 1.50,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/fly5bj2x_03%20Red%20Velvet.jpg",
    available: true,
    type: "individual"
  },
  {
    id: 4,
    name: "Avena con Arándanos",
    description: "Galletas de avena con arándanos frescos",
    priceUnit: 1.50,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/zzda5bdn_04%20Avena%20con%20Arandanos.jpg",
    available: true,
    type: "individual"
  },
  {
    id: 5,
    name: "Canela",
    description: "Galletas con canela y azúcar",
    priceUnit: 1.50,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/31lo74y1_05%20Canela.jpg",
    available: true,
    type: "individual"
  },
  {
    id: 6,
    name: "Coco",
    description: "Galletas con coco rallado",
    priceUnit: 1.50,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/njthbk5k_07%20Limon.jpg",
    available: true,
    type: "individual"
  },
  {
    id: 7,
    name: "Limón",
    description: "Galletas cítricas de limón con glaseado",
    priceUnit: 1.50,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/njthbk5k_07%20Limon.jpg",
    available: true,
    type: "individual"
  }
];

export const galletaPacks = [
  {
    id: 'pack5',
    name: "Pack de 5 Galletas",
    description: "Escoge 5 galletas de tus sabores favoritos",
    price: 6.00,
    quantity: 5,
    image: "/images/G10_Pack_Galletas.jpg",
    type: "pack"
  },
  {
    id: 'pack12',
    name: "Pack de 12 Galletas",
    description: "Escoge 12 galletas de tus sabores favoritos",
    price: 14.00,
    quantity: 12,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/oly2nak5_WhatsApp%20Image%202025-12-19%20at%2011.18.04%20PM.jpeg",
    type: "pack"
  },
  {
    id: 'custom',
    name: "Pack Personalizado",
    description: "Arma tu pack con tus sabores favoritos",
    basePrice: 14.00,
    minQuantity: 13,
    maxQuantity: 100,
    image: "https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/oly2nak5_WhatsApp%20Image%202025-12-19%20at%2011.18.04%20PM.jpeg",
    type: "custom"
  }
];

export const otherProducts = [
  { id: 2, name: "Empanadas", category: "Menú de Sal", description: "Pollo, ricotta con espinaca, jamón y queso" },
  { id: 3, name: "Desayunos Completos", category: "Desayunos", description: "Pancakes, bebidas y más" },
  { id: 4, name: "Bebidas Calientes y Frías", category: "Bebidas", description: "Café, jugos, batidos" },
  { id: 5, name: "Bocados Dulces", category: "Bocados", description: "Pequeños placeres para compartir" }
];

export const services = [
  {
    id: 1,
    title: "En el Local",
    description: "Disfruta de nuestros productos recién horneados en un ambiente acogedor",
    icon: "Store"
  },
  {
    id: 2,
    title: "Para Llevar",
    description: "Retira tu pedido en nuestra tienda y lleva la dulzura a casa",
    icon: "ShoppingBag"
  },
  {
    id: 3,
    title: "A Domicilio",
    description: "Entrega sin contacto en 2-60 minutos a tu puerta",
    icon: "Truck"
  }
];

export const locations = [
  {
    id: 1,
    name: "Matriz",
    address: "Sergio Jativa 175-147, Quito 170135, Ecuador",
    phone: "593984814807",
    googleRating: 5.0,
    googleReviews: 133,
    googleMapsUrl: "https://maps.app.goo.gl/VT989z9XA2WD1qGU8",
    googleReviewUrl: "https://g.page/r/CcimwRz2IYC5EBM/review",
    uberEatsUrl: "https://www.ubereats.com/store/brazolovers/fyyTV5PHVWmX4seakGdKWw",
    hours: {
      weekdays: "Lunes a Viernes: 08:30 - 19:00",
      saturday: "Sábados: 08:30 - 19:00",
      sunday: "Cerrado los Domingos"
    },
    workingHours: {
      monday: { open: "08:30", close: "19:00" },
      tuesday: { open: "08:30", close: "19:00" },
      wednesday: { open: "08:30", close: "19:00" },
      thursday: { open: "08:30", close: "19:00" },
      friday: { open: "08:30", close: "19:00" },
      saturday: { open: "08:30", close: "19:00" },
      sunday: null
    },
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7935735242893!2d-78.48250032413818!3d-0.18805999968180438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d59a8b8cf8a1a1%3A0x5caa7c3c3c3c3c3c!2sSergio%20J%C3%A1tiva%20175-147%2C%20Quito!5e0!3m2!1ses!2sec!4v1703657600000!5m2!1ses!2sec"
  },
  {
    id: 2,
    name: "Sucursal",
    address: "Edificio Niza, Av. Eloy Alfaro N33-21 y, Rusia, Quito",
    phone: "593984814807",
    googleRating: 4.9,
    googleReviews: 60,
    googleMapsUrl: "https://maps.app.goo.gl/Wm5GwyBrqQTLLkwG7",
    googleReviewUrl: "https://g.page/r/CdMiKVbMUAKlEBM/review",
    uberEatsUrl: "https://www.ubereats.com/store/brazolovers-eloy-alfaro-y-rusia/OJKHYtToWIu3l02iQCSWtA",
    hours: {
      weekdays: "Lunes a Viernes: 10:00 - 19:00",
      saturday: "Sábados: 09:00 - 18:00",
      sunday: "Domingos: 09:00 - 13:00"
    },
    workingHours: {
      monday: { open: "10:00", close: "19:00" },
      tuesday: { open: "10:00", close: "19:00" },
      wednesday: { open: "10:00", close: "19:00" },
      thursday: { open: "10:00", close: "19:00" },
      friday: { open: "10:00", close: "19:00" },
      saturday: { open: "09:00", close: "18:00" },
      sunday: { open: "09:00", close: "13:00" }
    },
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7935735242893!2d-78.47990002413818!3d-0.18299999968180438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d59a107f8c5a3d%3A0x9c9c9c9c9c9c9c9c!2sAv.%20Eloy%20Alfaro%20N33-21%2C%20Quito!5e0!3m2!1ses!2sec!4v1703657600000!5m2!1ses!2sec"
  }
];

// Cakes Section
export const cakes = [
  {
    id: 1,
    name: "La Reina",
    description: "Nuestro pastel estrella, totalmente personalizable. Elige tu sabor, relleno, exterior y topping.",
    image: "https://customer-assets.emergentagent.com/job_swiss-order/artifacts/l8jwey1n_Cake.jpg",
    isConfigurable: true,
    sizes: [
      { id: 'mediana', name: 'Mediana', portions: '12-15 personas', price: 28 },
      { id: 'grande', name: 'Grande', portions: '20-26 personas', price: 35 }
    ],
    available: true
  },
  {
    id: 2,
    name: "Rosca con Naranja y Arándanos",
    description: "Deliciosa rosca con sabor a naranja natural y arándanos.",
    image: "https://customer-assets.emergentagent.com/job_swiss-order/artifacts/c7hfwcul_Rosca%20Naranja.jpg",
    isConfigurable: false,
    price: 19,
    portions: '16 personas',
    available: true
  },
  {
    id: 3,
    name: "Rosca Navideña",
    description: "Rosca tradicional navideña con frutas confitadas.",
    image: "https://customer-assets.emergentagent.com/job_swiss-order/artifacts/my4ewdfu_Rosca%20navidad.jpg",
    isConfigurable: false,
    price: 19,
    portions: '16 personas',
    available: true
  },
  {
    id: 4,
    name: "Rosca Clásica",
    description: "Nuestra rosca tradicional, perfecta para cualquier ocasión.",
    image: "https://customer-assets.emergentagent.com/job_swiss-order/artifacts/whwtarph_Rosca.jpg",
    isConfigurable: false,
    price: 15,
    portions: '16 personas',
    available: true
  },
  {
    id: 5,
    name: "Pastel Imposible",
    description: "El famoso pastel imposible: flan y bizcocho de chocolate en una sola delicia.",
    image: "https://customer-assets.emergentagent.com/job_swiss-order/artifacts/anifjame_Torta%20Imposible.jpg",
    isConfigurable: false,
    price: 26,
    portions: '16-20 personas',
    available: true
  },
  {
    id: 6,
    name: "Tres Leches",
    description: "Bizcocho esponjoso bañado en tres leches, con crema batida y canela. Disponible en 4 sabores.",
    image: "https://customer-assets.emergentagent.com/job_cake-delivery-12/artifacts/ti03jvpj_08%20Tres%20Leches.jpg",
    isConfigurable: true,
    isTresLeches: true,
    sizes: [
      { id: 'mediana', name: 'Pequeña (Redonda)', portions: '~6 personas', price: 13 },
      { id: 'grande', name: 'Grande (Rectangular)', portions: '~12 personas', price: 22 }
    ],
    flavors: [
      { id: 'clasica', name: 'Clásica', extraPrice: 0, comboGroup: 'standard' },
      { id: 'chocolate', name: 'Chocolate', extraPrice: 0, comboGroup: 'standard' },
      { id: 'maracuya', name: 'Maracuyá', extraPrice: 0, comboGroup: 'premium' },
      { id: 'ron_pope', name: 'Ron Pope (+$2)', extraPrice: 2, comboGroup: 'premium' }
    ],
    comboPrice: 28,
    comboDescription: 'Pequeña + Grande',
    available: true
  }
];

// Opciones de configuración para La Reina
export const cakeConfigOptions = {
  sabores: [
    { id: 'vainilla', name: 'Vainilla', color: '#FFF8DC' },
    { id: 'chocolate', name: 'Chocolate', color: '#4A3728' },
    { id: 'marmoleada', name: 'Marmoleada', color: 'linear-gradient(45deg, #FFF8DC 50%, #4A3728 50%)' },
    { id: 'naranja', name: 'Naranja', color: '#FFA500' },
    { id: 'coco', name: 'Coco', color: '#FFFFF0' },
    { id: 'red_velvet', name: 'Red Velvet', color: '#8B0000' }
  ],
  rellenos: [
    { id: 'manjar', name: 'Manjar' },
    { id: 'chantilly', name: 'Crema Chantilly' },
    { id: 'chocolate', name: 'Chocolate' },
    { id: 'frosting_frutos', name: 'Frosting de Queso Crema con Frutos Rojos' },
    { id: 'maracuya', name: 'Maracuyá' },
    { id: 'chocolate_galletas', name: 'Chocolate con Galletas' },
    { id: 'chocoavellana', name: 'Chocoavellana (+$4)', extraPrice: 4 },
    { id: 'oreo', name: 'Crema de Oreo' }
  ],
  exteriores: [
    { id: 'desnuda', name: 'Desnuda (sin cobertura)' },
    { id: 'chocolate', name: 'Chocolate' },
    { id: 'manjar', name: 'Manjar' },
    { id: 'frosting_queso', name: 'Frosting de Queso Crema' },
    { id: 'chantilly', name: 'Chantilly' },
    { id: 'merengue_suizo', name: 'Merengue Suizo' },
    { id: 'semidesnuda_chantilly', name: 'Semidesnuda con crema chantilly' },
    { id: 'semidesnuda_frosting', name: 'Semidesnuda con frosting' },
    { id: 'semidesnuda_buttercream', name: 'Semidesnuda con buttercream' },
    { id: 'buttercream', name: 'Buttercream' }
  ],
  toppings: [
    { id: 'sin_topping', name: 'Sin Topping', extraPrice: 0 },
    { id: 'kitkat', name: 'KitKat', extraPrice: 0 },
    { id: 'frutos_rojos', name: 'Frutos Rojos', extraPrice: 0 },
    { id: 'maracuya', name: 'Maracuyá', extraPrice: 0 },
    { id: 'ferrero', name: 'Ferrero (+$4)', extraPrice: 4 },
    { id: 'pirulin', name: 'Pirulín (+$4)', extraPrice: 4 },
    { id: 'oreo', name: 'Oreo', extraPrice: 0 },
    { id: 'arandano_frambuesa', name: 'Arándano y Frambuesa', extraPrice: 0 },
    { id: 'galletas_chocochips', name: 'Galletas Chocochips', extraPrice: 0 },
    { id: 'galletas_red_velvet', name: 'Galletas Red Velvet', extraPrice: 0 }
  ]
};

// Panadería Section
export const panaderia = [
  {
    id: 1,
    name: "Pan de Jamón",
    description: "Tradicional pan navideño relleno de jamón, pasas y aceitunas. Aproximadamente 45 cm.",
    image: "https://customer-assets.emergentagent.com/job_cake-delivery-12/artifacts/ndhkd0j5_WhatsApp%20Image%202025-12-28%20at%2012.03.09%20AM.jpeg",
    price: 18,
    hasOption: true,
    options: [
      { id: 'tradicional', name: 'Tradicional', extraPrice: 0 },
      { id: 'queso_crema', name: 'Con Queso Crema', extraPrice: 2 }
    ],
    available: true
  },
  {
    id: 2,
    name: "Pan de Queso",
    description: "Delicioso pan relleno de queso derretido. Aproximadamente 45 cm.",
    image: "https://customer-assets.emergentagent.com/job_cake-delivery-12/artifacts/jbm7xq49_Gemini_Generated_Image_g530dmg530dmg530.png",
    price: 12,
    hasOption: false,
    available: true
  }
];

export const cachitos = [
  { id: 1, name: "Jamón y Tocino", price: 1.90 },
  { id: 2, name: "Jamón y Queso Crema", price: 2.20 },
  { id: 3, name: "Queso Manaba", price: 1.90 }
];

export const cachitosImage = "https://customer-assets.emergentagent.com/job_cake-delivery-12/artifacts/yyxxlz6k_Cachitos.jpg";

export const businessInfo = {
  name: "Brazolovers",
  tagline: "Bakershop & More",
  description: "Pastelería especializada en Brazos Gitanos artesanales, con más de 40 sabores únicos que combinan tradición, creatividad y calidad.",
  phone: "593984814807",
  hours: "Lunes a Domingo: 08:30 - 19:00",
  email: "info@brazolovers.com",
  social: {
    instagram: "https://www.instagram.com/brazolovers",
    facebook: "https://www.facebook.com/brazolovers",
    tiktok: "https://www.tiktok.com/@brazolovers",
    tripadvisor: "https://www.tripadvisor.com/Profile/brazolovers"
  }
};